<template>
  <div>
    <!-- grid toolbar -->
    <v-toolbar flat color="transparent" class="v-toolbar--grid">
      <!-- grid filter -->
      <v-menu
        v-model="filter.dialog"
        :close-on-content-click="false"
        :offset-y="true"
        max-width="300px"
        min-width="300px"
      >
        <template v-slot:activator="{ on }">
          <!-- filter button -->
          <v-btn class="mr-2" large v-on="on" :class="{'teal--text':filter.active}">
            <v-icon>mdi-tune</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-form ref="form" @submit.prevent="getItems">
            <v-card-title>Filter</v-card-title>
            <v-divider />
            <v-card-text>
              <v-btn-toggle
                v-model="filter.data.dari"
                mandatory
                class="mb-5"
                v-if="!$acl.check('isSekolah')"
              >
                <v-btn>Semua</v-btn>
                <v-btn>Ditugaskan</v-btn>
              </v-btn-toggle>
              <v-text-field
                v-model="filter.data.judul"
                hide-details
                outlined
                dense
                class="mb-3"
                placeholder="Cari berdasar judul"
                label="Judul"
              ></v-text-field>
              <v-combobox
                v-model="filter.data.label"
                :items="list.label.data"
                :loading="list.isLabelLoading"
                item-text="Name"
                item-value="ID"
                label="Label"
                placeholder="Label"
                class="mb-3"
                outlined
                multiple
                chips
                hide-details
                dense
                return-object
              >
                <template v-slot:selection="data">
                  <v-chip
                    small
                    dark
                    label
                    :key="JSON.stringify(data.item)"
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    :disabled="data.disabled"
                    @click:close="data.parent.selectItem(data.item.ID)"
                    :color="data.item.Color"
                  >{{ data.item.Name }}</v-chip>
                </template>
              </v-combobox>
              <v-combobox
                v-model="filter.data.kategori"
                :items="list.kategori.data"
                :loading="list.isKategoriLoading"
                item-text="Name"
                item-value="ID"
                label="Kategori"
                placeholder="Kategori"
                hide-details
                class="mb-3"
                outlined
                multiple
                chips
                dense
                return-object
              >
                <template v-slot:selection="data">
                  <v-chip
                    :key="JSON.stringify(data.item)"
                    v-bind="data.attrs"
                    small
                    label
                    dark
                    :input-value="data.selected"
                    :disabled="data.disabled"
                    @click:close="data.parent.selectItem(data.item.ID)"
                    :color="data.item.Color"
                  >{{ data.item.Name }}</v-chip>
                </template>
              </v-combobox>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-btn text @click="clearFilter">Ulang</v-btn>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="doFilter">Cari</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-menu>

      <!-- grid search -->
      <v-text-field
        v-model="search.data"
        append-icon="mdi-magnify"
        :label="app.grid.search"
        hide-details
        single-line
        solo
        clearable
      ></v-text-field>
      <v-spacer />

      <!-- grid button -->
      <v-btn class="ml-2" color="cyan white--text" large to="/konseling/baru">
        <span class="hidden-xs-only" v-text="app.grid.create"></span>
        <v-icon :right="!$vuetify.breakpoint.xsOnly">mdi-plus-box</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card class="mb-3">
      <v-tabs>
        <v-tab @click="tabFilter('pending')">
          {{app.discussion.open}}
          <v-chip small class="ml-2">{{summary.Pending}}</v-chip>
        </v-tab>
        <v-tab @click="tabFilter('done')">
          {{app.discussion.closed}}
          <v-chip small class="ml-2">{{summary.Done}}</v-chip>
        </v-tab>
        <v-tab @click="tabFilter('unreviewed')">
          {{app.discussion.unreviewed}}
          <v-chip small class="ml-2">{{summary.Unreviewed}}</v-chip>
        </v-tab>
      </v-tabs>
    </v-card>

    <!-- grid -->
    <v-data-table
      :headers="headers()"
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      :loading-text="app.grid.loading"
      :no-data-text="app.grid.noData"
      @click:row="openDiscussion"
      multi-sort
      class="elevation-1"
    >
      <template v-slot:item.Title="{ item }">
        <div v-if="$vuetify.breakpoint.xsOnly">
          <strong>{{item.Title}}</strong>
          &mdash;
          <span class="grey--text text--lighten-1">{{item.CreatedByUser.Name}}</span>
        </div>
        <v-list-item three-line class="px-0" v-else>
          <v-list-item-content>
            <v-list-item-title>
              <strong>{{item.Title}}</strong>
              &mdash;
              <span
                class="grey--text text--lighten-1"
              >{{item.CreatedByUser.Name}}</span>
              &emsp;
              <v-chip
                v-for="(label,index) in item.Labels"
                :key="label.ID"
                :class="{'ml-1':index>0}"
                x-small
                dark
                :title="label.Description"
                :color="label.Color || 'secondary'"
              >{{label.Name}}</v-chip>
            </v-list-item-title>
            <v-list-item-subtitle>
              {{item.Comment}}
              <!--<v-divider vertical v-if="item.Labels && item.Labels.length > 0" />
              -->
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>

      <template v-slot:item.Labels="{ item }">
        <v-chip
          label
          v-for="(label,index) in item.Labels"
          :key="label.ID"
          :class="{'ml-1':index>0}"
          small
          dark
          :title="label.Description"
          :color="label.Color || 'secondary'"
        >{{label.Name}}</v-chip>
      </template>

      <template v-slot:item.TotalReplies="{ item }">
        <span v-if="item.TotalReplies >0 ">
          <v-icon small left>mdi-message-outline</v-icon>
          {{item.TotalReplies}}
        </span>
      </template>
      <!-- custom updated date & by -->
      <template v-slot:item.LastUpdatedDate="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <span dark v-on="on">{{$format.relativeUpdatedDate(item)}}</span>
          </template>
          <span>{{$format.updatedDate(item)}}</span>
        </v-tooltip>
      </template>

      <!-- grid header -->
      <template v-slot:header.Actions>
        <div class="float-right">
          <v-btn icon v-if="filter.active" :class="{'mr-4':sort.active}" @click="clearFilter">
            <v-icon>mdi-filter-remove</v-icon>
          </v-btn>
          <v-btn icon v-if="sort.active" @click="clearSort">
            <v-icon>mdi-sort-variant-remove</v-icon>
          </v-btn>
        </div>
      </template>

      <!-- grid actions -->
      <template v-slot:item.Actions="{ item }">
        <div class="float-right">
          <v-btn class="mr-4" icon color="blue" @click="editItem(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" :loading="item.processing">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="deleteItem(item)">
                <v-list-item-icon>
                  <v-icon color="red">mdi-delete</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>Hapus</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      summary: {
        Pending: 0,
        Done: 0,
        Unreviewed: 0
      },
      filter: {
        dialog: false,
        active: false,
        data: {
          judul: "",
          kategori: "",
          label: ""
        },
        query: {}
      },
      sort: {
        active: false
      },
      search: {
        awaiting: false,
        data: ""
      },
      table: {
        awaiting: false
      },
      loading: false,
      options: {},
      items: [],
      totalItems: 0
    };
  },
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", ["isLabelLoading", "isKategoriLoading"])
  },
  methods: {
    ...mapActions("list", ["refreshLabel", "refreshKategori"]),
    headers() {
      let headers = [
        {
          value: "Title",
          text: "Pertanyaan",
          width: "50%"
        },
        {
          value: "Category.Name",
          text: "Kategori",
          sortable: false,
          width: "20%"
        },
        {
          value: "LastUpdatedDate",
          text: "Terakhir Diupdate",
          width: "20%"
        },
        {
          value: "TotalReplies",
          text: "",
          width: "10%",
          sortable: false
        }
      ];

      if (this.$vuetify.breakpoint.xsOnly) {
        headers.push({
          value: "Labels",
          text: "",
          sortable: false
        });
      }
      return headers;
    },
    async getItems() {
      this.loading = true;
      let payload = this.$format.payload(this.options);
      if (!this.filter.query.Logic) {
        let filter = new this.$dbflex();

        // inject sekolah
        if (this.$acl.check("isSekolah")) {
          let user = this.$session.get.user();
          filter.eq("IDSekolah", user.idSekolah);
        }

        filter.eq("IDParentDiscussion", "");
        filter.in("Status", ["open", "reopen"]);
        let query = filter.get();
        this.filter.query = query;
      }
      payload.Filter = this.filter.query;
      payload.Keyword = this.filter.active
        ? ""
        : this.$format.keyword(this.search.data);
      payload.KeywordFields = ["Title"];

      if (payload.Orders.length == 0) payload.Orders = ["-LastUpdatedDate"];

      try {
        const response = await this.$axios.post("/discussion/list", payload);
        const result = response.data;
        this.items = result.Data;
        this.totalItems = result.Total;
      } catch (error) {
        this.$dialog.notify.error(error, {
          position: this.app.notification.position
        });
      } finally {
        this.loading = false;
      }
    },
    async getSummaryCount() {
      this.loading = true;
      let payload = {},
        data = this.filter.data,
        user = this.$session.get.user();

      // inject sekolah
      if (this.$acl.check("isSekolah") && user) {
        payload.IDSekolah = user.idSekolah;
      }

      if (data.dari == 1) {
        if (user) payload.AssignedIDUser = user.id;
        else console.warn("user session is empty");
      }

      if (data.kategori && data.kategori.length > 0) {
        var filterKategori = data.kategori.map(k => k.ID);
        payload.IDCategory = filterKategori;
      }
      if (data.label && data.label.length > 0) {
        var filterLabel = data.label.map(l => l.ID);
        payload.IDLabels = filterLabel;
      }

      if (data.Keyword && data.Keyword.length > 0) {
        payload.Keyword = data.Keyword;
      }

      try {
        const response = await this.$axios.post(
          "/discussion/summarycount",
          payload
        );
        const result = response.data;

        this.summary = result.Data;
      } catch (error) {
        this.$dialog.notify.error(error, {
          position: this.app.notification.position
        });
      } finally {
        this.loading = false;
      }
    },
    async openDiscussion(item) {
      this.$router.push(`konseling/${item.ID}`);
    },

    async deleteItem(item) {
      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menghapus data ?"
      });
      if (confirmation) {
        item.processing = true;
        this.$axios
          .delete(`/discussion/${item.ID}`)
          .then(res => {
            if (res.data.Success) {
              this.$dialog.notify.success(res.data.Message, {
                ...this.app.notification
              });
            }
            this.getSummaryCount();
            this.getItems();
          })
          .catch(error => {
            this.$dialog.notify.error(error, {
              position: this.app.notification.position
            });
          })
          .finally(() => {
            item.processing = false;
          });
      }
    },
    test(data) {
      console.log(data);
      console.log(JSON.stringify(data));
    },
    tabFilter(status) {
      let filter = new this.$dbflex();
      filter.eq("IDParentDiscussion", "");
      if (status == "pending") {
        filter.in("Status", ["open", "reopen"]);
      }
      if (status == "done") {
        filter.eq("Status", "verified");
        filter.gt("Review", 0);
      }
      if (status == "unreviewed") {
        filter.eq("Status", "verified");
        filter.eq("Review", 0);
      }
      let query = filter.get();
      if (query) {
        this.filter.query = query;
        this.getItems();
        this.getSummaryCount();
      }
    },
    doFilter() {
      let filter = new this.$dbflex();
      let data = this.filter.data;

      filter.eq("IDParentDiscussion", "");
      if (data.judul) filter.eq("Title", data.judul);

      let user = this.$session.get.user();

      // inject sekolah
      if (this.$acl.check("isSekolah")) {
        filter.eq("IDSekolah", user.idSekolah);
      }

      if (data.dari == 1) {
        if (user) filter.eq("AssignedIDUser", user.id);
        else console.warn("user session is empty");
      }

      if (data.kategori && data.kategori.length > 0) {
        var filterKategori = data.kategori.map(k => k.ID);
        filter.in("IDCategory", filterKategori);
      }
      if (data.label && data.label.length > 0) {
        var filterLabel = data.label.map(l => l.ID);
        filter.in("IDLabels", filterLabel);
      }
      let query = filter.get();
      if (query) {
        this.filter.dialog = false;
        this.filter.active = true;
        this.filter.query = query;
        this.search.data = "";
        this.getItems();
        this.getSummaryCount();
      }
    },
    resetFilter() {
      this.filter.dialog = false;
      this.$refs.form.reset();
    },
    clearFilter() {
      this.$refs.form.reset();
      this.filter.active = false;
      this.filter.query = {};
      this.search.data = "";
      this.getItems();
      this.getSummaryCount();
    },
    clearSort() {
      this.filter.sort = false;
      this.options.sortBy = [];
      this.options.sortDesc = [];
    }
  },
  watch: {
    options: {
      handler(v) {
        var delay = 500;
        if (!this.table.awaiting) {
          setTimeout(() => {
            this.sort.active = v.sortBy.length > 0;
            this.getSummaryCount();
            this.getItems();
            this.table.awaiting = false;
          }, delay);
        }
        this.table.awaiting = true;
      },
      deep: true
    },
    "search.data"() {
      var delay = 1000;
      if (!this.search.awaiting) {
        setTimeout(() => {
          this.getItems();
          this.getSummaryCount();
          this.search.awaiting = false;
        }, delay);
      }
      this.search.awaiting = true;
    }
  },
  async created() {
    this.refreshKategori();
    this.refreshLabel();
  },
  mounted() {}
};
</script>

<style lang="scss">
</style>